/**
 * Um roteador de 40 linhas, e nao uma biblioteca.
 *
 * O aplicativo tem cinco rotas de tela e nenhuma rota de API (o Caddy responde
 * `/api/*` antes do `index.html`). Isso e menos do que qualquer biblioteca de
 * roteamento resolve, e cada dependencia a mais e uma que precisa de manutencao,
 * deauditoria de CSP e de uma versao a atualizar.
 *
 * **`replace` em mudanca de sessao e obrigatorio.** Entrar, sair e aceitar
 * convite mexem na sessao; sem `replace`, o botao "voltar" do Android traz a
 * pagina de acesso que ja foi resolvida e a casa fica presa num laco de recarrega.
 */

export type AoNavegar = (caminho: string) => void;

const ouvintes: AoNavegar[] = [];

export function caminhoAtual(): string {
  return window.location.pathname;
}

/** Troca a URL **sem** recarregar e sem empilhar uma entrada no historico. */
export function trocar(caminho: string): void {
  window.history.replaceState(null, "", caminho);
  notificar();
}

/** Navegacao de verdade, que empilha no historico. */
export function ir(caminho: string): void {
  window.history.pushState(null, "", caminho);
  notificar();
}

function notificar(): void {
  for (const ouvinte of ouvintes) {
    ouvinte(caminhoAtual());
  }
}

/** Liga o roteador e devolve a funcao que desliga. */
export function comecar(): () => void {
  const aoClicar = (evento: MouseEvent): void => {
    if (evento.defaultPrevented || evento.button !== 0 || evento.metaKey) {
      return;
    }
    // `closest` devolve `null` quando nao ha ancavo, e `noUncheckedIndexedAccess`
    // deixa isso explicito. O `target` vazio e o caso do proprio elemento.
    const alvo = (evento.target as Element | null)?.closest("a");
    if (alvo === null || alvo === undefined || alvo.hasAttribute("download")) {
      return;
    }
    if ((alvo as HTMLAnchorElement).target !== "") {
      return;
    }
    const href = alvo.getAttribute("href") ?? "";
    if (!href.startsWith("/")) {
      return;
    }
    evento.preventDefault();
    ir(href);
  };

  window.addEventListener("popstate", notificar);
  document.addEventListener("click", aoClicar);

  return () => {
    window.removeEventListener("popstate", notificar);
    document.removeEventListener("click", aoClicar);
  };
}

export function aoMudar(ouvinte: AoNavegar): void {
  ouvintes.push(ouvinte);
}